import Sentry from "@similarweb/sentry-logger";

import { fetchDemandTopics } from "../helpers/fetchDemandTopics";
import type { ITopic, ITopicSingleRawData, ITopicsRawData } from "../types";

let flattenedData: ITopicsRawData;
let topicLookup: Record<string, ITopic> = {};

const flatten = (topicRecord: Record<string, ITopicSingleRawData>): [ITopicsRawData, Record<string, ITopic>] => {
    const flattened: ITopicsRawData = {};
    const lookup: Record<string, ITopic> = {};

    const helper = (record: Record<string, ITopicSingleRawData>) => {
        Object.entries(record).forEach(([key, topic]) => {
            const { Children, ...restOfTopic } = topic;
            flattened[key] = restOfTopic;
            lookup[topic.Id] = { ...restOfTopic, Name: key };

            if (Children) {
                helper(Children);
            }
        });
    };

    helper(topicRecord);
    return [flattened, lookup];
};

const initializeTopicsService = async () => {
    if (flattenedData) {
        return;
    }
    try {
        const topics = await fetchDemandTopics();
        [flattenedData, topicLookup] = flatten(topics);
    } catch (error) {
        Sentry.error("Failed to initialize topics service:", error);
    }
};

const getTopicById = async (id: string): Promise<ITopic | undefined> => {
    await initializeTopicsService();
    return topicLookup[id];
};

const getFlattenedData = async (): Promise<ITopicsRawData> => {
    await initializeTopicsService();
    return flattenedData;
};

export const topicsService = {
    getFlattenedData,
    getTopicById,
};
